import { $createParagraphNode, $getSelection, $isRangeSelection } from "lexical";
import { $createQuoteNode, $isQuoteNode } from "@lexical/rich-text";
import { $setBlocksType } from "@lexical/selection";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Quote } from "lucide-react";

import { useButtonState } from "../useButtonState";

export function BlockquoteButton() {
    const [editor] = useLexicalComposerContext();
    const isActive = useButtonState(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return false;
        const anchorNode = selection.anchor.getNode();
        const topLevel = anchorNode.getTopLevelElement();
        return topLevel !== null && $isQuoteNode(topLevel);
    });

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            data-active={isActive}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
                editor.update(() => {
                    const selection = $getSelection();
                    if (!$isRangeSelection(selection)) return;
                    $setBlocksType(selection, () =>
                        isActive ? $createParagraphNode() : $createQuoteNode(),
                    );
                });
            }}
            title="Blockquote"
            aria-label="Blockquote"
        >
            <Quote size={16} />
        </button>
    );
}
